import React from "react";
import "../styles/ToggleSwitch.css";

/**
 * A labeled on/off switch. Purely presentational — the parent owns the
 * checked state and the API call in onChange.
 */
export default function ToggleSwitch({ label, checked, onChange, disabled, tone = "default" }) {
  return (
    <label className={"toggleswitch toggleswitch-" + tone}>
      <span className="toggleswitch-label">{label}</span>
      <span className="toggleswitch-control">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="toggleswitch-slider" />
      </span>
    </label>
  );
}
